import TimePicker from "./index.vue";

import { register } from "@various/utils";

export const UiTimePicker = register.use(TimePicker, "component") as typeof TimePicker;

export * from "./src/component";

export default UiTimePicker;
